export default __webpack_public_path__ + "943e2f3d8022ffad726f5506a9e5cf09.png";